import { Directive, ElementRef, Input, OnChanges, Renderer2, inject } from "@angular/core";

@Directive({
  selector: "[AsteriskMessage]",
  standalone: true,
})
export class AsteriskMessageDirective implements OnChanges {
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  constructor() {}

  ngOnChanges(change: any) {
    const asterisk = this.el.nativeElement;
    asterisk.innerHTML = "";
    if (this.messageList.length > 0) {
      const outerDiv = this.createElement("div", "asterisk-message-outer mt-2", "");
      this.renderer.appendChild(outerDiv, this.createElement("span", "asterisk-alert font-red-light fw-bold", "*Error Messages"));
      this.renderer.appendChild(asterisk, outerDiv);
      this.renderer.appendChild(asterisk, this.createElement("div", "row mt-2 mx-0 pb-3 border-red asterisk-container", ""));
      const row = asterisk.lastElementChild as HTMLElement;
      this.messageList.forEach(element => {
        const div = this.createElement("div", "col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 mt-3 font-red-light", "* ");
        const span = this.createElement("span", "asterisk-message font-red-light", element);
        this.renderer.appendChild(div, span);
        this.renderer.appendChild(row, div);
      });
    }
  }

  @Input() messageList: string[] = [];

  createElement(tag: string, className: string, value: string) {
    const element = this.renderer.createElement(tag);
    const text = this.renderer.createText(value);

    const classList = className?.split(" ");
    classList.forEach(item => {
      this.renderer.addClass(element, item);
    });
    value && this.renderer.appendChild(element, text);
    return element;
  }
}
